/* LUYA · aleatoriedad en toda la tienda (se ejecuta en cada visita o refresco)
   1) [data-luya-shuffle]: mezcla los productos de la cuadrícula y muestra solo la cantidad indicada.
   2) [data-luya-cover-pool]: cambia la miniatura de cada colección por la portada de un producto al azar. */
(() => {
  if (window.luyaRandomStoreInstalled) return;
  window.luyaRandomStoreInstalled = true;

  const shuffle = (list) => {
    for (let i = list.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  };

  /* Tras mezclar, el carrusel debe recalcular sus páginas; si no, el contador muestra números negativos. */
  const refreshSlider = (grid) => {
    const slider = grid.closest('slider-component');
    if (!slider) return;
    try {
      if (slider.slider) slider.slider.scrollLeft = 0;
      if (typeof slider.resetPages === 'function') slider.resetPages();
      else if (typeof slider.initPages === 'function') slider.initPages();
      if (typeof slider.update === 'function') slider.update();
    } catch (error) {}
  };

  const shuffleGrid = (grid) => {
    if (grid._luyaShuffled) return;
    grid._luyaShuffled = true;
    const show = parseInt(grid.dataset.luyaShuffle, 10) || 0;
    const items = shuffle(Array.from(grid.children));
    items.forEach((item, index) => {
      item.hidden = show > 0 && index >= show;
      item.style.removeProperty('--animation-order');
      grid.append(item);
    });
    grid.classList.add('luya-shuffled');
    refreshSlider(grid);
    if (window.customElements && !customElements.get('slider-component')) {
      customElements.whenDefined('slider-component').then(() => requestAnimationFrame(() => refreshSlider(grid)));
    }
    window.addEventListener('load', () => refreshSlider(grid), { once: true });
  };

  const swapCover = (media) => {
    if (media._luyaDone) return;
    media._luyaDone = true;
    const img = media.querySelector('img');
    if (!img) return;
    let pool = [];
    try { pool = JSON.parse(media.dataset.luyaCoverPool || '[]'); } catch (error) { pool = []; }
    pool = pool.filter(Boolean);
    if (!pool.length) return;
    const current = img.getAttribute('src');
    const choices = pool.length > 1 ? pool.filter((src) => src !== current) : pool;
    const src = choices[Math.floor(Math.random() * choices.length)];
    const fallback = current;
    img.addEventListener('error', () => { img.removeAttribute('srcset'); if (fallback) img.src = fallback; }, { once: true });
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.loading = 'eager';
    img.src = src;
  };

  const run = (root) => {
    (root || document).querySelectorAll('[data-luya-shuffle]').forEach(shuffleGrid);
    (root || document).querySelectorAll('[data-luya-cover-pool]').forEach(swapCover);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
  else run();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
